import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

/**
 * React Query client configuration.
 *
 * React Query handles server state management:
 * - Automatic caching of API responses
 * - Background refetching for fresh data
 * - Deduplication of concurrent requests
 * - Automatic retries on failure
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 30 seconds
      staleTime: 30 * 1000,
      // Keep cached data for 5 minutes after it becomes stale
      gcTime: 5 * 60 * 1000,
      // Retry failed queries up to 3 times
      retry: 3,
      // Don't refetch when window regains focus in development
      refetchOnWindowFocus: import.meta.env.PROD,
    },
  },
})

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a <div id="root"></div> in your HTML.'
  )
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/v2">
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)
